"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _InfoLabel = _interopRequireDefault(require("../../../../components/InfoLabel"));
var _BranchedCompletionConfig = _interopRequireDefault(require("../BranchedCompletionConfig"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Boilerplate = window.cccisd.boilerplate;
var PostSurveyConfig = function PostSurveyConfig(_ref) {
  var deploymentId = _ref.deploymentId,
    fields = _ref.fields,
    submitFailed = _ref.submitFailed;
  var allowRetake = fields.allowRetake,
    closedMessage = fields.closedMessage,
    completedMessage = fields.completedMessage,
    completionMessage = fields.completionMessage,
    completionUrl = fields.completionUrl,
    endpoint = fields.endpoint,
    hash = fields.hash,
    individualPasscode = fields.individualPasscode,
    logoutOnCompletion = fields.logoutOnCompletion,
    passcodeCompletionButtonText = fields.passcodeCompletionButtonText,
    postCompletionAction = fields.postCompletionAction,
    requireLogin = fields.requireLogin,
    respondentConfig = fields.respondentConfig,
    showReviewButtonOnCompletion = fields.showReviewButtonOnCompletion,
    useEndpoint = fields.useEndpoint;
  var url = Boilerplate.url("/d/".concat(hash.value));
  if (respondentConfig.value === 'manual' && individualPasscode.value) {
    completionUrl.value = endpoint.value && useEndpoint.value ? "".concat(url, "/").concat(endpoint.value) : url;
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: postCompletionAction,
    label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "When the respondent completes the Quest..."
    })
  }, postCompletionAction.value !== 'branch' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-check"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-check-label"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: "form-check-input",
    type: "radio",
    checked: postCompletionAction.value === 'message',
    onChange: function onChange() {
      return postCompletionAction.onChange('message');
    }
  }), ' ', "Show completion message")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-check mb-2"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-check-label"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: "form-check-input",
    type: "radio",
    checked: postCompletionAction.value === 'url',
    onChange: function onChange() {
      return postCompletionAction.onChange('url');
    }
  }), ' ', "Go to URL"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-check"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-check-label"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: "form-check-input",
    type: "checkbox",
    checked: postCompletionAction.value === 'branch',
    onChange: function onChange() {
      var newValue = postCompletionAction.value === 'branch' ? 'message' : 'branch';
      postCompletionAction.onChange(newValue);
    }
  }), ' ', "Advanced..."))), respondentConfig.value === 'managed' && postCompletionAction.value !== 'branch' && requireLogin.value && /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-check mb-3"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-check-label"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: "form-check-input",
    type: "checkbox",
    checked: logoutOnCompletion.value,
    onChange: function onChange() {
      return logoutOnCompletion.onChange(!logoutOnCompletion.value);
    }
  }), ' ', "Logout on Completion")), postCompletionAction.value === 'url' && /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    field: completionUrl,
    label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Completion URL",
      tooltip: "A URL to send the respondent once they finish the Quest. (Must include protocol. E.g., 'https://www.google.com' instead of 'www.google.com')"
    })
  }), postCompletionAction.value === 'message' && allowRetake.value && !logoutOnCompletion.value && /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-check mb-3"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-check-label"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: "form-check-input",
    type: "checkbox",
    checked: showReviewButtonOnCompletion.value || false,
    onChange: function onChange() {
      return showReviewButtonOnCompletion.onChange(!showReviewButtonOnCompletion.value);
    }
  }), ' ', "Show Review Button", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: "Show button to return respondent to beginning of the Quest."
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-primary"
  }, /*#__PURE__*/_react["default"].createElement(_info["default"], null))))), postCompletionAction.value === 'message' && /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: completionMessage,
    label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Completion message",
      tooltip: "Message to show respondents when they finish the Quest."
    })
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.WysiwygEditor, {
    field: completionMessage,
    inputStyle: {
      minHeight: '100px'
    }
  }), individualPasscode.value && respondentConfig.value === 'manual' && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '40%',
      marginTop: '0.5em'
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    field: passcodeCompletionButtonText,
    label: "Button Text to return to passcode screen"
  }))), postCompletionAction.value === 'branch' && /*#__PURE__*/_react["default"].createElement(_BranchedCompletionConfig["default"], {
    deploymentId: deploymentId,
    fields: fields,
    submitFailed: submitFailed
  }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: allowRetake,
    label: "Should respondents be allowed to edit their answers after submitting?"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-check form-check-inline"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-check-label"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: "form-check-input",
    type: "radio",
    onChange: function onChange() {
      return allowRetake.onChange(true);
    },
    checked: allowRetake.value,
    name: "retake"
  }), ' ', "Yes")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-check form-check-inline"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-check-label"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: "form-check-input",
    type: "radio",
    onChange: function onChange() {
      return allowRetake.onChange(false);
    },
    checked: !allowRetake.value,
    name: "retake"
  }), ' ', "No")))), !allowRetake.value && /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: completedMessage,
    label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Already completed message",
      tooltip: "Message to show respondents if they attempt to access this Quest after they have already finished."
    })
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.WysiwygEditor, {
    field: completedMessage,
    inputStyle: {
      minHeight: '100px'
    }
  })), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: closedMessage,
    label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Quest closed message",
      tooltip: "Message to show respondents if the Quest they attempt to access is closed."
    })
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.WysiwygEditor, {
    field: closedMessage,
    inputStyle: {
      minHeight: '100px'
    }
  })));
};
PostSurveyConfig.propTypes = {
  deploymentId: _propTypes["default"].number,
  fields: _propTypes["default"].object,
  submitFailed: _propTypes["default"].bool
};
var _default = exports["default"] = PostSurveyConfig;